module.exports = __webpack_public_path__ + "static/media/loadLogo.c92672ce.svg";